import { Components, Theme } from '@mui/material';
import { typography } from '../typography';
import { getResponsiveFontSize } from '../../shared/utils';

export const getMuiButton = (theme: Theme): Components['MuiButton'] => ({
  defaultProps: {
    variant: 'contained',
    color: 'primary',
    disableElevation: true,
  },
  styleOverrides: {
    root: ({ ownerState }) => ({
      ...(ownerState?.size === 'large' && {
        borderRadius: theme.shape.borderRadius * 2,
        height: 48,
        fontSize: getResponsiveFontSize('1rem'),
      }),
      ...(ownerState?.variant === 'watchduty-text-uppercase' && {
        textTransform: 'uppercase',
        fontWeight: typography.fontWeightBold,
      }),
    }),
  },
});
